import heart from "../images/сердечко-дата.png";
import { motion } from "motion/react";

export const Date = () => {
  const dates = [
    { day: "15", name: "пн", isTarget: false },
    { day: "16", name: "вт", isTarget: false },
    { day: "17", name: "ср", isTarget: false },
    { day: "18", name: "чт", isTarget: false },
    { day: "19", name: "пт", isTarget: false },
    { day: "20", name: "сб", isTarget: false },
    { day: "21", name: "вс", isTarget: true },
  ];

  return (
    <div className="w-full mt-15 px-4">
      <h3 className="text-lg text-[var(--primary)]">Июнь 2026</h3>

      <div className="relative w-full mt-4">
        <motion.img
          src={heart}
          alt="Сердечко"
          className="absolute -right-1.5 -bottom-1.5 z-0 h-8 w-8 opacity-90 pointer-events-none"
          animate={{
            rotate: [0, 10, -10, 10, -10, 0],
            y: [0, -8, 2, -6, 0],
          }}
          transition={{
            duration: 4.2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <div className="relative z-10 flex items-center justify-between">
          {dates.map((date, idx) => (
            <motion.div
              key={date.day}
              className="flex flex-col items-center"
              animate={{
                y: [0, -8, 2, -6, 0],
                rotate: [0, 1.5, -1, 0.5, 0],
              }}
              transition={{
                duration: 4.2,
                repeat: Infinity,
                delay: idx * 0.18,
                ease: "easeInOut",
              }}
            >
              <span className="text-base uppercase">{date.name}</span>
              <span className="text-base font-bold uppercase">{date.day}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};
